import { Controller } from '@hotwired/stimulus';
import { SearchesMixin } from '../../../mixins/searches_mixin';
import { TurboMixin } from '../../../mixins/turbo_mixin';

export default class extends Controller {
  static targets = [
    'searchWrapper',
    'searchInput',
    'contractorIdInput',
  ];

  initialize() {
    SearchesMixin(this, "Contractor")
    TurboMixin(this)

    this.initializeSearch(
      {
        selector: this.searchWrapperTarget,
        query: {},
        noResultsMessage: "Nie znaleziono pasujących wyników",
      },
      this.searchCallbacks(),
      this.customResultsTemplate(),
    );
  }

  connect() {
    this.searchInputTarget.addEventListener("input", this.handleInputChange)
  }

  disconnect() {
    this.searchInputTarget.removeEventListener("input", this.handleInputChange)
  }

  handleInputChange = () => {
    this.clearFrame();
    this.contractorIdInputTarget.value = '';
  }

  clearFrame = () => {
    const frame = document.getElementById("selected_contractor_info")
    if (frame) {
      frame.innerHTML = ""
    }
  }

  searchCallbacks() {
    return {
      onSelect: (result) => {
        this.contractorIdInputTarget.value = result.id;

        if (this.searchWrapperTarget.dataset.turboUrl) {
          this.turboGet(this.searchWrapperTarget.dataset.turboUrl, { id: result.id });
        }

        // prevent reappearing of the search results
        setTimeout(() => {
          $(this.searchWrapperTarget).search("set value", result.description);
          $(this.searchWrapperTarget).search("hide results");
          this.searchInputTarget.blur();
        }, 100);

        // prevent default action (closing search results and selecting value).
        return false;
      },
    };
  }
}
